import Tool, { type ToolArgs } from '../../../tools/Tool';
import { Transforms } from 'slate';
import { type DividerLineElement } from '../../../types/aha-editor';
import EditorUtils from '../../../AhaEditorUtils/EditorUtils';

// Insert a divider line into the editor.
class ToolInsertDividerLine extends Tool {
  static toolName = 'Divider line';
  static iconClass = 'fa-regular fa-minus';
  static shortcut = 'cmd+-';

  static action({ editor }: ToolArgs): void {
    if (!editor) return;
    if (!editor.selection) return;

    const dividerLine: DividerLineElement = {
      type: 'divider-line',
      children: [{ text: '' }],
    };

    Transforms.insertNodes(editor, dividerLine);
    Transforms.insertNodes(editor, EditorUtils.emptyParagraph());
  }
}

export default ToolInsertDividerLine;
